export default __webpack_public_path__ + "static/media/LalitSir.8f103e47.webp";